import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropertyGallery from './PropertyGallery';
import PropertyFloorPlans from './PropertyFloorPlans';
import SidebarDetails from 'components/artectum/sidebar-filters/SidebarDetail';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';
import { Helmet } from 'react-helmet';

const ShopDetails = ({ projectData }) => {
    const publicUrl =  "/";
    const [activeTab, setActiveTab] = useState(projectData?.floor_plans?.[0]?.id || 'liton_tab_3_1'); // Default to the first tab

    const scrollToMap = () => {
        const mapTab = projectData?.floor_plans?.find(plan => plan.name === 'liton_tab_3_3');
        if (mapTab) {
            setActiveTab(mapTab.id); // Set the active tab to the tab with name 'liton_tab_3_3'
            setTimeout(() => {
                const mapElement = document.getElementById(mapTab.id);
                if (mapElement) {
                    const offsetTop = mapElement.getBoundingClientRect().top + window.pageYOffset - 200;
                    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
                }
            }, 100);
        }
    };

    return (
        <div className="ltn__shop-details-area pb-10">
            <Helmet>
                <title>Proyectos con Baldosas y Mosaicos | Artectum</title>
                <meta name="description" content="Conoce nuestros proyectos en construcción y diseño con baldosas, terrazos y celosías de concreto. Inspírate y cotiza el tuyo." />
            </Helmet>
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12">
                        <div className="ltn__shop-details-inner ltn__page-details-inner">
                            <div className="d-flex align-items-center justify-content-between mb-0 mt-5 mt-md-5">
                                <h1 className="m-0">{projectData?.title}</h1>
                                {/* <div className="ltn__blog-meta mb-1 ml-3 d-none d-lg-block mb-0">
                                    <ul className="d-flex">
                                        <li className="ltn__blog-category mr-2">
                                            <Link className="mb-0" to="#">{projectData?.categories}</Link>
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                            <div className="ltn__banner-img mt-4 mb-1">
                                <ImageWithBaseApi
                                    className="w-100"
                                    src={projectData?.banner_image}
                                    alt="Banner"
                                    style={{ maxHeight: '200px', objectFit: 'cover' }}
                                />
                            </div>
                            <div className="ltn__blog-meta mb-4">
                                <ul>
                                    <li className="ltn__blog-date" style={{ cursor: 'pointer' }} onClick={scrollToMap}>
                                        <span className="ltn__secondary-color"><i className="flaticon-pin" /></span> {projectData?.location}
                                    </li>
                                    <li className="ltn__blog-date" style={{ cursor: 'pointer' }}>
                                        <Link to="#">
                                            <span className="ltn__secondary-color"><i className="far fa-calendar-alt" /></span>{projectData?.date}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <h4 className="title-2 mt-0">Descripción</h4>
                            <p>{projectData?.description}</p>
                            {projectData.media_item && <PropertyGallery publicUrl={publicUrl} mediaItems={projectData.media_item} />}
                            {projectData.floor_plans.length > 0 && <PropertyFloorPlans publicUrl={publicUrl} floorPlans={projectData.floor_plans} activeTab={activeTab} setActiveTab={setActiveTab} />}
                        </div>
                    </div>
                    <SidebarDetails publicUrl={publicUrl} data={projectData} />
                </div>
            </div>
        </div>
    );
}

export default ShopDetails;